import React from 'react';
export function Metrics() {
  return <section className="w-full py-16 px-6 md:px-12" data-id="element-495">
      <div className="max-w-6xl mx-auto" data-id="element-496">
        <h2 className="text-4xl md:text-5xl font-bold mb-16 text-center" data-id="element-497">
          Save Hours Every Week
        </h2>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-498">
          <div className="bg-white bg-opacity-5 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-499">
            <div className="text-[#3B82F6] text-4xl font-bold mb-4" data-id="element-500">
              1-2 hrs
            </div>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-501">saved per meeting</p>
          </div>
          <div className="bg-white bg-opacity-5 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-502">
            <div className="text-[#3B82F6] text-4xl font-bold mb-4" data-id="element-503">85%</div>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-504">
              of users say they feel more prepared
            </p>
          </div>
          <div className="bg-white bg-opacity-5 rounded-xl p-8 flex flex-col items-center text-center" data-id="element-505">
            <div className="text-[#3B82F6] text-4xl font-bold mb-4" data-id="element-506">
              31 hrs/month
            </div>
            <p className="text-[#F5F7FA] text-opacity-80" data-id="element-507">
              lost to meeting chaos—reclaimed with AI
            </p>
          </div>
        </div>
      </div>
    </section>;
}